import React from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import SEO from '@/components/utils/SEO';
import FeaturedSection from '@/components/sections/FeaturedSection';
import CategorySection from '@/components/sections/CategorySection';
import ValuedPeopleSection from '@/components/sections/ValuedPeopleSection';
import AboutMeSection from '@/components/sections/AboutMeSection';
import TrendingSection from '@/components/sections/TrendingSection';
import ManamuMediaSection from '@/components/sections/ManamuMediaSection';
import HandshakedBrandsSection from '@/components/sections/HandshakedBrandsSection';
import NewsletterSection from '@/components/sections/NewsletterSection';
import ScrollToTopButton from '@/components/ui/ScrollToTopButton';

const Index: React.FC = () => {
  return (
    <>
      <SEO 
        title="Manamu Media - Premier Business Media Platform"
        description="Discover inspiring success stories, business insights, and market analysis from leading entrepreneurs and industry experts. Your premier destination for business media content."
        keywords={[
          'business media',
          'entrepreneurship',
          'success stories',
          'business insights',
          'market analysis',
          'entrepreneur platform',
          'business success',
          'industry experts'
        ]}
      />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        
        <main className="flex-1">
          <FeaturedSection />
          <CategorySection />
          <ValuedPeopleSection />
          <AboutMeSection />
          <TrendingSection />
          <ManamuMediaSection />
          <HandshakedBrandsSection />
          <NewsletterSection />
        </main>
        
        <Footer />
        <ScrollToTopButton />
      </div>
    </>
  );
};

export default Index;
